import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIButton from 'UIComponents/button/UIButton'; // @ts-expect-error untyped import

import OutlinedHeartIcon from '../../Icons/OutlinedHeartIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useSaveFavoriteLesson, useSaveFavoriteTrack } from '../../ContentCards/ReducedContentCard/hooks/useSaveFavoriteContent';
import I18n from 'I18n';
const FullWidthButton = styled(UIButton).withConfig({
  displayName: "FavoritesToggleIcon__FullWidthButton",
  componentId: "sc-4g3x79-0"
})(["width:100%;justify-content:space-between;display:flex;"]);

const FavoritesToggleIcon = (_ref) => {
  let {
    isSaved,
    onIconClick,
    width = '24px',
    useFullButton,
    disableTooltip
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["isSaved", "onIconClick", "width", "useFullButton", "disableTooltip"]);

  const handleOnClick = useCallback(e => {
    e.stopPropagation();
    e.preventDefault();
    if (onIconClick) onIconClick();
  }, [onIconClick]);

  if (useFullButton) {
    return /*#__PURE__*/_jsxs(FullWidthButton, {
      onClick: handleOnClick,
      use: "unstyled",
      children: [isSaved ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.favorites.tooltips.savedHover"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.favorites.tooltips.unsavedHover"
      }), /*#__PURE__*/_jsx(OutlinedHeartIcon, Object.assign({
        isFilled: isSaved,
        style: {
          width: '24px'
        }
      }, props))]
    });
  }

  return /*#__PURE__*/_jsx(UITooltip, {
    open: disableTooltip ? false : undefined,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.favorites.tooltips.${isSaved ? 'savedHover' : 'unsavedHover'}`
    }),
    children: /*#__PURE__*/_jsx(UIButton, {
      "aria-label": I18n.text('learningCenter.favorites.save'),
      "data-test-id": "favorite-button",
      onClick: handleOnClick,
      style: {
        width,
        padding: '1px'
      },
      use: "unstyled",
      children: /*#__PURE__*/_jsx(OutlinedHeartIcon, Object.assign({
        isFilled: isSaved
      }, props))
    })
  });
};

export const FavoritesTrackToggleIcon = (_ref2) => {
  let {
    trackId,
    useFullButton,
    width
  } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, ["trackId", "useFullButton", "width"]);

  const [isSaved, toggleSavedItem] = useSaveFavoriteTrack({
    trackId: Number(trackId)
  });
  return /*#__PURE__*/_jsx(FavoritesToggleIcon, Object.assign({
    isSaved: isSaved,
    onIconClick: toggleSavedItem,
    useFullButton: useFullButton,
    width: width
  }, props));
};
export const FavoritesLessonToggleIcon = (_ref3) => {
  let {
    lessonId,
    useFullButton,
    width
  } = _ref3,
      props = _objectWithoutPropertiesLoose(_ref3, ["lessonId", "useFullButton", "width"]);

  const [isSaved, toggleSavedItem] = useSaveFavoriteLesson({
    lessonId: Number(lessonId)
  });
  return /*#__PURE__*/_jsx(FavoritesToggleIcon, Object.assign({
    isSaved: isSaved,
    onIconClick: toggleSavedItem,
    useFullButton: useFullButton,
    width: width
  }, props));
};
export default FavoritesToggleIcon;